import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";

@Component({
  selector: 'app-cqmns-classification-summary',
  templateUrl: './cqmns-classification-summary.component.html',
  styleUrls: ['./cqmns-classification-summary.component.css']
})
export class CqmnsClassificationSummaryComponent implements OnInit {
  issues: any;
  hostUrl;
  projectId: any;
  assign = [];
  assigntoCount = [];
  sourceDetails: any;
  sourceNames: any = [];
  assignTo = false;
  classifications = [];
  noOfClassifications = [];
  classifications3 = [];
  noOfClassifications3 = [];
  myChart: any;
  canvas: any;
  ctx: any;
  colors = [
    "rgb(69,39,160)",
    "rgba(3,66,128)",
    "rgba(100,118,137)",
     "rgba(26,187,156)",
    "rgba(255,219,105)",

  ];
  userId: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private userService: UserService, private authService: AuthService, 
  ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl = this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

   // this.projectId = this.route.snapshot.params["projectId"];
   this.projectId = localStorage.getItem("projectId");
    /* To get the number of all the countBySource */
    this.http
      .get(
        encodeURI(this.hostUrl + "/api/issue/countBySource/" + this.projectId)
      )
      .subscribe(data => {
        for (let k in data) {
          if (k !== "null") {
            this.classifications.push(k);
            this.noOfClassifications.push(data[k] ? data[k] : 0);
          }
        }
      });
    this.http
      .get(
        encodeURI(
          this.hostUrl + "/api/issue/countByClassification/" + this.projectId
        )
      )
      .subscribe(data => {
        for (let k in data) {
          if (k !== "null") {
            this.classifications3.push(k);
            this.noOfClassifications3.push(data[k] ? data[k] : 0);
          }
        }
        let sum = 0;
        for (let i = 0; i < this.noOfClassifications3.length; i++) {
          sum += this.noOfClassifications3[i];
        }
        if (sum === 0) {
          this.myChart.data.datasets[0].data.push(1);
          this.myChart.data.datasets[0].backgroundColor.push("rgba(0,0,0,0.5)");
          this.myChart.update();
        } else {
          this.updateChart(this.myChart);
        }
      });
  }
  ngAfterViewInit() {
    Chart.defaults.global.defaultFontColor = "#000";
    this.canvas = document.getElementById("myChart");
    this.ctx = this.canvas.getContext("2d");
    this.myChart = new Chart(this.ctx, {
      type: "doughnut",
      data: {
        labels: [],
        
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            pointStyle: 'circle',
           
          }
        ]
      },
      options: {
        cutoutPercentage: 70,
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        
        legend: {
          display: true,
          position: 'left',
          labels: {
            usePointStyle: true,
            fontSize:12,
            fontColor:'#2a3f54'
          }
           // place legend on the right side of chart
       },
      }
    });
  }
  updateChart(myTrend) {
    for (let i = 0; i < this.classifications3.length; i++) {
      myTrend.data.labels.push(this.classifications3[i]);
      myTrend.data.datasets[0].data.push(this.noOfClassifications3[i]);
      myTrend.data.datasets[0].backgroundColor.push(this.getColor(i));
    }

    myTrend.update();
  }
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getColor(num) {
    if (num <= 7) {
      return this.colors[num];
    } else {
      this.getRandomColor();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-classification-summary/cqmns-classification-summary.component.ts